/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios'

export default {
  API: {
    GENIE_SESSION_INIT: '/genie/genieSession',
    GENIE_LOGGING: '/genie/genieLogging',
  },

  cachedHash: {},
  cancelTokens: [],

  postRequest(authUser, url, payload, headers) {
    if (authUser.accessToken) {
      if (headers == null) headers = {};
      headers['Authorization'] = 'Bearer ' + authUser.accessToken;
      
      if(authUser.config) {
        headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
      }
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      let cancelTokenKey = url;
      if (this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token,
      };

      return axios.post(url, payload, options);
    } else {
      return null;
    }
  },
  
  async initGenieSession(authUser, transcripts) {
    const url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.GENIE_SESSION_INIT;

    const payload = {
      "sid": authUser.sessionId,
      ...transcripts
    }

    return this.postRequest(authUser, url, payload);
  },
  
  async postGenieLogging(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.GENIE_LOGGING;
    return this.postRequest(authUser, url, payload);
  },
}